import { render, staticRenderFns } from "./seriesTabs.vue?vue&type=template&id=bfc50b78&scoped=true"
import script from "./seriesTabs.vue?vue&type=script&lang=ts"
export * from "./seriesTabs.vue?vue&type=script&lang=ts"
import style0 from "./seriesTabs.vue?vue&type=style&index=0&id=bfc50b78&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfc50b78",
  null
  
)

export default component.exports